export interface GroupOption {
  value: 'none' | 'tag' | 'status' | 'createdAt' | 'updatedAt' | 'responsible' | 'deadlineAt';
  label: string;
  icon?: string;
}

export type GroupValue = 'none' | 'tag' | 'status' | 'createdAt' | 'updatedAt' | 'responsible' | 'deadlineAt';

export const GROUP_OPTIONS: readonly GroupOption[] = [
  { value: 'none', label: 'Группировка' },
  { value: 'tag', label: 'По тэгу' },
  { value: 'status', label: 'По статусу' },
  { value: 'responsible', label: 'По исполнителю' },
  { value: 'createdAt', label: 'По дате создания' },
  { value: 'updatedAt', label: 'По дате обновления' },
  { value: 'deadlineAt', label: 'По дедлайну' },
];
